export const AiPromptRoleInvalidTypes = [
  'SYSTEM',
  'SYS',
  'USER',
  'SUPER_USER',
  'AGENT',
  'ANY',
  'ANY_ONE',
  'ALL',
  'EVERYONE',
  'NULL',
  'INVALID',
  'UNDEFINED',
  'NONE',
  'NO_ONE',
  'ADMIN',
  'ADMINISTRATOR',
  'SELF',
  'PLAYER',
  'CASE',
  'SCENARIO'
]

export const AiPromptRoleTypes = [
  'NULL',
  'ANYONE',
  'PROVIDER',
  'PATIENT_0',
  'PATIENT_1',
  'PATIENT_2',
  'PATIENT_3',
  'PATIENT_4',
  'PATIENT_5',
  'PATIENT_6',
  'PATIENT_7',
  'PATIENT_8',
  'PATIENT_9'
]

// Common roles offered as type-ahead suggestions. Free text is still allowed;
// these are only hints. Multi-word roles use underscores to satisfy /^[A-Z_]+$/.
export const AiPromptRoleSuggestions = [
  'MOTHER',
  'FATHER',
  'PARENT',
  'SISTER',
  'BROTHER',
  'SIBLING',
  'SPOUSE',
  'BOYFRIEND',
  'GIRLFRIEND',
  'SIGNIFICANT_OTHER',
  'FAMILY_MEMBER',
  'BYSTANDER',
  'INTERPRETER',
  'NURSE',
  'PHYSICIAN',
  'RESPIRATORY_THERAPIST',
  'PHARMACIST',
  'TECHNICIAN',
  'MEDICAL_ASSISTANT',
  'PRECEPTOR',
  'NURSING_PARTNER',
  'EMS_PARTNER',
  'PARAMEDIC',
  'DISPATCHER',
  'SECURITY',
  'LAW_ENFORCEMENT',
  'FIREFIGHTER',
  'SOCIAL_WORKER',
  'CHAPLAIN'
]

// Corrections for known misspellings.
export const RoleAutoCorrections = {
  INTERPRETTER: 'INTERPRETER'
}

// Levenshtein edit distance between two strings.
export function editDistance(a = '', b = '') {
  const rows = a.length + 1;
  const cols = b.length + 1;
  const dist = Array.from({ length: rows }, () => new Array(cols).fill(0));
  for (let i = 0; i < rows; i++) dist[i][0] = i;
  for (let j = 0; j < cols; j++) dist[0][j] = j;
  for (let i = 1; i < rows; i++) {
    for (let j = 1; j < cols; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      dist[i][j] = Math.min(
        dist[i - 1][j] + 1,
        dist[i][j - 1] + 1,
        dist[i - 1][j - 1] + cost
      );
    }
  }
  return dist[rows - 1][cols - 1];
}

// Returns the nearest suggestion within edit distance <= 2 for a likely
// misspelling. Returns null for empty roles or exact suggestion matches, so
// deliberate custom roles are never flagged.
export function findRoleSuggestion(role) {
  if (!role || AiPromptRoleSuggestions.includes(role)) return null;
  let best = null;
  let bestDistance = Infinity;
  for (const suggestion of AiPromptRoleSuggestions) {
    const distance = editDistance(role, suggestion);
    if (distance < bestDistance) {
      bestDistance = distance;
      best = suggestion;
    }
  }
  return bestDistance <= 2 ? best : null;
}